<template>
    <div>
        <UserAnalytics/>
    </div>
</template>

<script>
import UserAnalytics from '../Users/UserAnalytics.vue'
export default {
    components: {
        UserAnalytics
    }
}
</script>